// extracted by mini-css-extract-plugin
export default {"guideLink":"PreviewGuide_guideLink__yQ1wf"};